import * as tslib_1 from "tslib";
import { Attr, Value, Record, Text } from '@swim/recon';
import { DirectiveForm } from './directive-form';
import { EachDirective } from './each-directive';
var EachForm = (function (_super) {
    tslib_1.__extends(EachForm, _super);
    function EachForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(EachForm.prototype, "tag", {
        get: function () {
            return 'each';
        },
        enumerable: true,
        configurable: true
    });
    EachForm.prototype.cast = function (item) {
        if (item.tag === this.tag) {
            var directive_1 = new EachDirective();
            item.forEach(function (item) {
                this.materializeDirectiveParam(directive_1, item);
            }, this);
            return directive_1;
        }
        return undefined;
    };
    EachForm.prototype.materializeDirectiveParam = function (directive, item) {
        if (item instanceof Attr && item.key.value === this.tag) {
            if (item.value instanceof Record) {
                directive._bindings = item.value.commit();
            }
        }
        else if (item.key instanceof Text) {
            var key = item.key.value;
            if (key === 'key') {
                directive._keySelector = item.toValue();
            }
        }
        else if (item instanceof Value) {
            directive._template.push(item);
        }
    };
    EachForm.Form = new EachForm();
    return EachForm;
}(DirectiveForm));
export { EachForm };
DirectiveForm.addGlobal(EachForm.Form);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZWFjaC1mb3JtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZWFjaC1mb3JtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLEVBQU8sSUFBSSxFQUFFLEtBQUssRUFBRSxNQUFNLEVBQUUsSUFBSSxFQUFDLE1BQU0sYUFBYSxDQUFDO0FBQzVELE9BQU8sRUFBQyxhQUFhLEVBQUMsTUFBTSxrQkFBa0IsQ0FBQztBQUMvQyxPQUFPLEVBQUMsYUFBYSxFQUFDLE1BQU0sa0JBQWtCLENBQUM7QUFHL0M7SUFBOEIsb0NBQTRCO0lBQTFEOztJQWdDQSxDQUFDO0lBL0JDLHNCQUFJLHlCQUFHO2FBQVA7WUFDRSxNQUFNLENBQUMsTUFBTSxDQUFDO1FBQ2hCLENBQUM7OztPQUFBO0lBRUQsdUJBQUksR0FBSixVQUFLLElBQVU7UUFDYixFQUFFLENBQUMsQ0FBQyxJQUFJLENBQUMsR0FBRyxLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDO1lBQzFCLElBQU0sV0FBUyxHQUFHLElBQUksYUFBYSxFQUFFLENBQUM7WUFDdEMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxVQUFVLElBQVU7Z0JBQy9CLElBQUksQ0FBQyx5QkFBeUIsQ0FBQyxXQUFTLEVBQUUsSUFBSSxDQUFDLENBQUM7WUFDbEQsQ0FBQyxFQUFFLElBQUksQ0FBQyxDQUFDO1lBQ1QsTUFBTSxDQUFDLFdBQVMsQ0FBQztRQUNuQixDQUFDO1FBQ0QsTUFBTSxDQUFDLFNBQVMsQ0FBQztJQUNuQixDQUFDO0lBRUQsNENBQXlCLEdBQXpCLFVBQTBCLFNBQXdCLEVBQUUsSUFBVTtRQUM1RCxFQUFFLENBQUMsQ0FBQyxJQUFJLFlBQVksSUFBSSxJQUFJLElBQUksQ0FBQyxHQUFHLENBQUMsS0FBSyxLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDO1lBQ3hELEVBQUUsQ0FBQyxDQUFDLElBQUksQ0FBQyxLQUFLLFlBQVksTUFBTSxDQUFDLENBQUMsQ0FBQztnQkFDakMsU0FBUyxDQUFDLFNBQVMsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLE1BQU0sRUFBRSxDQUFDO1lBQzVDLENBQUM7UUFDSCxDQUFDO1FBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFDLElBQUksQ0FBQyxHQUFHLFlBQVksSUFBSSxDQUFDLENBQUMsQ0FBQztZQUNwQyxJQUFNLEdBQUcsR0FBRyxJQUFJLENBQUMsR0FBRyxDQUFDLEtBQUssQ0FBQztZQUMzQixFQUFFLENBQUMsQ0FBQyxHQUFHLEtBQUssS0FBSyxDQUFDLENBQUMsQ0FBQztnQkFDbEIsU0FBUyxDQUFDLFlBQVksR0FBRyxJQUFJLENBQUMsT0FBTyxFQUFFLENBQUM7WUFDMUMsQ0FBQztRQUNILENBQUM7UUFBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUMsSUFBSSxZQUFZLEtBQUssQ0FBQyxDQUFDLENBQUM7WUFDakMsU0FBUyxDQUFDLFNBQVMsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7UUFDakMsQ0FBQztJQUNILENBQUM7SUFFZSxhQUFJLEdBQUcsSUFBSSxRQUFRLEVBQUUsQ0FBQztJQUN4QyxlQUFDO0NBQUEsQUFoQ0QsQ0FBOEIsYUFBYSxHQWdDMUM7U0FoQ1ksUUFBUTtBQWlDckIsYUFBYSxDQUFDLFNBQVMsQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLENBQUMifQ==